// extracted by mini-css-extract-plugin
module.exports = {"container":"info-course_container__2OM82","title":"info-course_title__1pdCQ","image":"info-course_image__1DXhp"};